import { createSlice } from "@reduxjs/toolkit";

// Slice для управления состоянием загрузки PDF
// нужен чтобы отслеживать состояние загрузки PDF файлов пока текущие файлы не загружены, новые не удастся загрузить
// блокировалась кнопка загрузки PDF
export const UploadPDF = createSlice({
    name: "uploadPDF",
    initialState: {
        upload:false,
    },
    reducers: {
        onChangeUploadPDF: (state, {payload}) => {
            state.upload = payload.upload;
            return state;
        },
    },

});

export const { onChangeUploadPDF } = UploadPDF.actions;
export const UploadPDFSelector = (state) => state.uploadPDF;